<template>
  <div :id="eId" class="mask" v-show="is_show_mask" :style="'width:'+mask_width()+'px;left:'+mask_left()+'px;height:'+mask_height()+'px;top:'+mask_top()+'px'">
  </div>
</template>

<script>
export default {
  name: "SelectDemo",
  props: {
    eId: String,
    viewMode:String,
    box_screen_left:Number,
    box_screen_top: Number,
    categoryType: Number,
    fileData: Array,
  },
  data() {
    return {
      is_show_mask:  false,
      start_x :  0,
      start_y  :  0,
      end_x  :  0,
      end_y  :  0,
    }
  },
  methods: {
    mask_width() {
      return Math.abs(this.end_x - this.start_x);
    },
    mask_height() {
      return Math.abs(this.end_y - this.start_y);
    },
    mask_left() {
      return Math.min(this.start_x, this.end_x) - this.box_screen_left ;
    },
    mask_top() {
      return Math.min(this.start_y, this.end_y) - this.box_screen_top;
    },
    collide(rect1, rect2) {
      const maxX = Math.max(rect1.x + rect1.width, rect2.x + rect2.width);
      const maxY = Math.max(rect1.y + rect1.height, rect2.y + rect2.height,);
      const minX = Math.min(rect1.x, rect2.x);
      const minY =  Math.min(rect1.y, rect2.y);
      if (maxX - minX <= rect1.width + rect2.width && maxY - minY <= rect1.height + rect2.height) {
        return true;
      } else {
        return false;
      }
    },
    resSetXY() {
      this.start_x = 0;
      this.start_y = 0;
      this.end_x = 0;
      this.end_y = 0;
    },
    handleMouseDown(event) {
      if(event.shiftKey == false) {
        return false;
      }
      // console.log('handleMouseDown event.shiftKey',event.shiftKey, new Date())
      // if (event.target.tagName === 'SPAN') return false;
      this.is_show_mask = true;
      this.start_x = event.clientX;
      this.start_y = event.clientY;
      this.end_x = event.clientX;
      this.end_y = event.clientY;
      // console.log('handleMouseDown event.target.tagName=', event.target.tagName, this.start_x, this.start_y, new Date())
      document.body.addEventListener('mousemove', this.handleMouseMove);
      document.body.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseMove(event) {
      if(event.shiftKey == false) {
        return false;
      }
      // console.log('handleMouseDown event.shiftKey',event.shiftKey, new Date())
      // console.log('handleMouseMove  this.is_show_mask',  this.is_show_mask, event.clientX, event.clientY, new Date())
      this.end_x = event.clientX;
      this.end_y = event.clientY;
    },
    handleMouseUp() {
      if(this.is_show_mask == false) {
        return false;
      }
      // console.log('handleMouseUp event.shiftKey',event.shiftKey, new Date())
      document.body.removeEventListener('mousemove', this.handleMouseMove);
      document.body.removeEventListener('mouseup', this.handleMouseUp);
      this.is_show_mask = false;
      this.handleDomSelect();
      this.resSetXY();
    },
    handleDomSelect() {
      console.log('handleDomSelect viewMode=', this.viewMode, new Date())
      const dom_mask=  window.document.querySelector('.mask');
      const rect_select = dom_mask.getClientRects()[0];
      // this.$emit('handleDomSelect', rect_select)
      let selectIds= [];
      if(this.viewMode == 'list') {
        document.querySelectorAll('.el-table__row').forEach((node, index) => {
          const rects = node.getClientRects()[0];
          if (this.collide(rects, rect_select) === true) {
            // console.log(node, index, 'select', new Date())
            if(index < this.fileData.length) {
              selectIds.push(this.fileData[index].id)
            }
          }
        });
      } else if(this.viewMode == 'grid'){
        document.querySelectorAll('.file-grid-item').forEach((node, index) => {
          const rects = node.getClientRects()[0];
          if (this.collide(rects, rect_select) === true) {
            // console.log(node, index, 'select', new Date())
            if(index < this.fileData.length) {
              selectIds.push(this.fileData[index].id)
            }
          }
        });
      }
      this.$emit('handleDomSelect', selectIds)
    }
  }
}
</script>

<style scoped>
.mask {
  position: absolute;
  background: #409eff;
  opacity: 0.4;
}
</style>